<template>
  <v-dialog
    v-model="dialog"
    max-width="80%"
    max-height="80%"
    :style="{ zIndex: 200 }"
    @keydown.esc="cancel"
    @click:outside="cancel"
  >
    <v-card>
      <v-app-bar
        absolute
        color="primary"
        scroll-target="#scrolling-ParallelViewer"
        id="header-ParallelViewer"
        class="parallelViewer__header"
      >
        <v-toolbar-title class="white--text">
          <template v-if="data.length > 0">
            {{ name }}&nbsp;({{ id }})
          </template>
          <template v-else>
            {{ $t("message.common.no_id", { id: id }) }}
          </template>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.native="get_excel" :disabled="data.length == 0" dark>
                mdi-file-excel
              </v-icon>
            </template>
            <span>{{ $t("message.common.get_excel") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon color="white" v-on="on" class="ma-2" @click.native="cancel">
                mdi-close
              </v-icon>
            </template>
            <span>{{ $t("message.common.close") }}</span>
          </v-tooltip>
        </v-toolbar-items>
      <template v-slot:extension>
        <v-toolbar-items>
          <v-card class="d-flex justify-center search-area" width="100%">
            <v-card flat class="pa-2">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                clearable
                :label="$t('message.common.first_lang')"
                v-model="search_source"
              >
              </v-text-field>
            </v-card>
            <v-card flat class="pa-2">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                clearable
                :label="$t('message.common.second_lang')"
                v-model="search_target"
              >
              </v-text-field>
            </v-card>
          </v-card>
        </v-toolbar-items>
        </template>
      </v-app-bar>
      <v-sheet
        id="scrolling-ParallelViewer"
        class="overflow-y-auto"
        :max-height="sheetHeight"
      >
        <v-data-table
          :headers="headers"
          :items="data"
          class="elevation-1"
          :page.sync="page"
          :options.sync="options"
          :footer-props="{
            'items-per-page-options': [10, 100, 200, 500]
          }"
        >
          <template v-slot:item.index="{ item }">
            <template v-if="'eid' in item.comment">
              <span class="grey--text">{{ Array.isArray(item.index) ? item.index.join("-") : item.index }}</span>
            </template>
            <template v-else>
              {{ Array.isArray(item.index) ? item.index.join("-") : item.index }}
            </template>
          </template>
          <template v-slot:item.source="{ item }">
            <div class="bidi">
              <template v-if="'eid' in item.comment">
                <span class="grey--text">{{ item.source }}</span>
              </template>
              <template v-else>
                {{ item.source }}
              </template>
            </div>
          </template>
          <template v-slot:item.target="{ item }">
            <div class="bidi">
              <template v-if="'eid' in item.comment">
                <span class="grey--text">{{ item.target }}</span>
              </template>
              <template v-else>
                {{ item.target }}
              </template>
            </div>
          </template>
          <template v-slot:item.comment="{ item }">
            <template v-if="'eid' in item.comment">
              <span class="grey--text">
                {{ $t("error." + get_eid(item.comment.eid), item.comment.param) }}
              </span>
            </template>
            <template v-else>
              -
            </template>
          </template>
        </v-data-table>
      </v-sheet>
      <v-overlay
        :absolute="true"
        :value="progress_overlay"
      >
        <v-progress-circular
          :value="progress"
        >
          {{ progress }}
        </v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>

<script>
import saveAs from "file-saver";
import XLSX from "xlsx";
import { http_error } from "../js/http_error";
import { get_eid } from "../js/get_eid";
import sanitize_filename from "sanitize-filename";
import 'xlsx.utils.sanitize_sheet_name';

export default {
  name: 'parallel_viewer',
  mixins: [
    http_error, get_eid
  ],
  props: {
    mode: String
  },
  data: function(){
    return {
      module_id: "84",
      dialog: false,
      name: "",
      id: "",
      data: [],
      progress: 0,
      progress_overlay: false,
      search_source: "",
      search_target: "",
      window: window,
      sheetHeight: 0,
      page: 1,
      options: {
        itemsPerPage: 10,
        sortBy: ['index'],
        sortDesc: [false]
      },
      abort_controller: null
    };
  },
  methods: {
    open(name, type, id) {
      this.name = name;
      this.id = id;
      this.dialog = true;
      this.progress_overlay = true;
      this.progress = 0;
      this.abort_controller = new AbortController();
      this.$http.get(this.$store.getters.api_endpoint + "/" + this.get_prefix() + type + "/" + id + "/json",
                     {
                       onDownloadProgress: function( progressEvent ) {
                         this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                       }.bind(this),
                       signal: this.abort_controller.signal
                     })
        .then( response => {
          this.progress = 100;
          this.progress_overlay = false;
          this.abort_controller = null;
          if(this.$store.getters.debug){
            console.log("response.data:" + JSON.stringify(response.data));
          }
          var data = [];
          if(!("format" in response.data) || response.data.format.version === 1){
            // format version 1
            for(var key in response.data.contents){
                var content = response.data.contents[key];
                var comment = content.comment;
                if(typeof comment === "string"){
                  try{
                     comment = JSON.parse(comment);
                   }catch(e){
                     comment = {};
                   }
                }
                data.push({
                  index: parseInt(key) + 1,
                  source: content.s,
                  target: content.t,
                  comment: comment
                });
            }
          }else if(response.data.format.version === 2){
            // format version 2
            var max_key_digit = 1;
            for(var key in response.data.contents){
              max_key_digit = Math.max(max_key_digit, ("" + (parseInt(key) + 1)).length);
            }
            for(var key in response.data.contents){
              for(var sub_key in response.data.contents[key]){
                var max_sub_sub_key_digit = 1;
                for(var sub_sub_key in response.data.contents[key][sub_key]){
                  max_sub_sub_key_digit = Math.max(max_sub_sub_key_digit, ("" + (parseInt(sub_sub_key) + 1)).length);
                }
                for(var sub_sub_key in response.data.contents[key][sub_key]){
                  var content = response.data.contents[key][sub_key][sub_sub_key];
                  var comment = content.comment;
                  if(typeof comment === "string"){
                    try{
                       comment = JSON.parse(comment);
                     }catch(e){
                       comment = {};
                     }
                  }
                  var index = ('0'.repeat(max_key_digit) + (parseInt(key) + 1)).slice(-max_key_digit);
                  if(response.data.contents[key][sub_key].length !== 1){
                    index += '-' + ('0'.repeat(max_sub_sub_key_digit) + (parseInt(sub_sub_key) + 1)).slice(-max_sub_sub_key_digit);
                  }
                  data.push({
                    index: index,
                    source: content.source.sentence,
                    target: content.target.sentence,
                    comment: comment
                  });
                }
              }
            }
          }else{
            // format version 3, 4
            for(const [no, top_data] of response.data.contents.entries()){
              for(const [sub_no, sub_data] of top_data.contents.entries()){
                for(const [sub_sub_no, sub_sub_data] of sub_data.contents.entries()){
                  var comment = sub_sub_data.comment;
                  if(typeof comment === "string"){
                    try{
                       comment = JSON.parse(comment);
                     }catch(e){
                       comment = {};
                     }
                  }
                  var indexes = [(parseInt(no) + 1)];
                  if(top_data.contents.length > 1){
                    indexes.push(parseInt(sub_no) + 1);
                  }
                  if(sub_data.contents.length > 1){
                    indexes.push(parseInt(sub_sub_no) + 1);
                  }
                  data.push({
                    index: indexes,
                    source: sub_sub_data.source.sentence,
                    target: sub_sub_data.target.sentence,
                    comment: comment
                  });
                }
              }
            }
          }
          this.data = data;
          this.createSheetHeight();
        })
        .catch(error => {
          this.progress_overlay = false;
          if(this.abort_controller !== null){
            this.abort_controller.abort();
          }
          this.abort_controller = null;
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    cancel() {
      if(this.abort_controller !== null){
        this.abort_controller.abort();
      }
      this.abort_controller = null;
      this.dialog = false;
      this.name = "";
      this.id = "";
      this.data = [];
      this.search_source = "",
      this.search_target = "",
      this.page = 1;
      this.options.itemsPerPage = 10;
      window.removeEventListener('resize', this.createSheetHeight);
      this.remove_range();
    },
    get_prefix: function(){
      if(this.mode === "user"){
        return "";
      }else{
        return this.mode + "/";
      }
    },
    // sheet内の高さを設定
    createSheetHeight() {
      const $header = document.getElementById('header-ParallelViewer');
      const headerHeight = $header.clientHeight;
      this.sheetHeight = window.innerHeight * 0.8 - headerHeight;
      window.addEventListener('resize', this.createSheetHeight);
    },
    remove_range(){
      const selection = window.getSelection();
      if(selection.toString()){
        const range = selection.getRangeAt(0);
        selection.removeAllRanges(range);
      }
    },
    get_excel: function(){
      // データー変換
      var excel_data = [];
      for(var data of this.data){
        var comment = "";
        if("eid" in data.comment){
          comment = this.$i18n.t("error." + this.get_eid(data.comment.eid), data.comment.param);
        }
        excel_data.push([
          data.index,
          data.source,
          data.target,
          comment
        ]);
      }
      excel_data.sort(function(a, b) {
        if(Array.isArray(a[0]) && Array.isArray(b[0])){
          for(var i=0; i<Math.min(a[0].length, b[0].length); i++){
            if(a[0][i] !== b[0][i]){
              return a[0][i] - b[0][i];
            }
          }
          return 0;
        }else{
          return a[0] - b[0];
        }
      })
      for(var row of excel_data){
        if(Array.isArray(row[0])){
          row[0] = row[0].join("-");
        }
      }
      excel_data.unshift([
        "No.",
        this.$i18n.t("message.common.first_lang"),
        this.$i18n.t("message.common.second_lang"),
        this.$i18n.t("message.parallel_viewer.comment")
      ]);

      // 以降はExcel処理
      var wb = XLSX.utils.book_new();

      if(this.$store.getters.debug){
        console.log(excel_data);
      }
      var ws_name = (this.name + "(" + this.id + ")").substring(0, 31);
      var ws = XLSX.utils.aoa_to_sheet(excel_data);
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, XLSX.utils.sanitize_sheet_name(ws_name));

      /* bookType can be any supported output type */
      var wopts = { bookType:'xlsx', bookSST:false, type:'binary' };
      var wbout = XLSX.write(wb,wopts);
      function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      }
      /* the saveAs call downloads a file on the local machine */
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}),
             sanitize_filename(this.name + ".xlsx"));
    }
  },
  computed: {
    headers: function() {
      return [
        {
          text: "No.",
          value: 'index',
          sort: (a, b) => {
            if(Array.isArray(a) && Array.isArray(b)){
              for(var i=0; i<Math.min(a.length, b.length); i++){
                if(a[i] !== b[i]){
                  return a[i] - b[i];
                }
              }
              return 0;
            }else{
              return a - b;
            }
          }
        },
        {
          text: this.$i18n.t("message.common.first_lang"),
          value: 'source',
          filter: value => {
            if(this.search_source === "" || this.search_source === null){
              return true;
            }
            return value.toLowerCase().indexOf(this.search_source.toLowerCase()) !== -1;
          }
        },
        {
          text: this.$i18n.t("message.common.second_lang"),
          value: 'target',
          filter: value => {
            if(this.search_target === "" || this.search_target === null){
              return true;
            }
            return value.toLowerCase().indexOf(this.search_target.toLowerCase()) !== -1;
          }
        },
        {
          text: this.$i18n.t("message.parallel_viewer.comment"),
          value: 'comment',
          sortable: false
        }
      ];
    }
  }
}
</script>
<style>
div.v-toolbar__extension {
  display: block;
  background-color: #FFF;
  padding: 0;
  padding-top: 8px;
}
.search-area {
  border-radius: 0 !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px -2px rgba(0, 0, 0, 0.12);
}
.v-data-table-header > tr > th {
  padding: 24px 16px 12px 16px;
}
.parallelViewer__header {
  position: relative !important;
}
.bidi {
  unicode-bidi: plaintext;
}
</style>
